import { render } from "./DocumentOpen.vue?vue&type=template&id=524448d8"
import script from "./DocumentOpen.vue?vue&type=script&lang=js"
export * from "./DocumentOpen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__